/** @format */

import {TanStackTableData} from '../types';

interface Options {
  data: TanStackTableData[];
  search?: string;
  searchByColumnIds?: string[];
}

const filterData = ({data, searchByColumnIds, search}: Options): TanStackTableData[] => {
  return data.filter(row => {
    let allColumnIds = searchByColumnIds || [];
    if (!searchByColumnIds || !search) {
      allColumnIds = Object.keys(row).filter(id => id !== 'subRows') as string[];
    }
    for (let i = 0; i < allColumnIds.length; i++) {
      const key = allColumnIds[i];
      const value = String(row[key]).toLowerCase();
      const searchString = search?.trim().toLowerCase() || '';
      if (value.includes(searchString)) {
        return true;
      }
    }
  });
};

export {filterData};
